export enum UserPermission {
    ACTIVITY_READ = 'ACTIVITY_READ',
    ACTIVITY_EDIT = 'ACTIVITY_EDIT',
    ACTIVITY_CREATE = 'ACTIVITY_CREATE',
    ACTIVITY_DELETE = 'ACTIVITY_DELETE',
    ACTIVITY_READ_TEAM = 'ACTIVITY_READ_TEAM',
    ACTIVITY_EDIT_TEAM = 'ACTIVITY_EDIT_TEAM',
    ACTIVITY_CREATE_TEAM = 'ACTIVITY_CREATE_TEAM',
    ACTIVITY_DELETE_TEAM = 'ACTIVITY_DELETE_TEAM',
    API_KEY = 'API_KEY',
    TILE_READ = 'TILE_READ',
    TILE_FAV = 'TILE_FAV',
    TILE_EDIT = 'TILE_EDIT',
    TILE_CREATE = 'TILE_CREATE',
    TILE_ARCHIVE = 'TILE_ARCHIVE',
    LAYER_READ = 'LAYER_READ',
    LAYER_EDIT = 'LAYER_EDIT',
    LAYER_CREATE = 'LAYER_CREATE',
    REPORT_CREATE = 'REPORT_CREATE',
    TEMPLATE_READ = 'TEMPLATE_READ',
    TEMPLATE_EDIT = 'TEMPLATE_EDIT',
    TEMPLATE_CREATE = 'TEMPLATE_CREATE',
    USER_CREATE = 'USER_CREATE',
    USER_EDIT = 'USER_EDIT',
    USER_READ = 'USER_READ',
    USER_EDIT_PERMISSION = 'USER_EDIT_PERMISSION',
    INTERFACE_CONFIG = 'INTERFACE_CONFIG',
    WEBHOOK_CONFIG = 'WEBHOOK_CONFIG',
    MANAGE_SUBSCRIPTION = 'MANAGE_SUBSCRIPTION',
}
